import { throttle } from '@/utils';
import React from 'react';

type Handler<E extends Event | React.SyntheticEvent> = (e: E) => void | Promise<void>;

/**
 * `handler`에 쓰로틀링 1초를 적용하고, `beforeExecute()`가 끝나기 전까지 추가 호출을 방지한다.
 */
export const throttleAndWaitPrev = <E extends Event | React.SyntheticEvent>(
  handler?: Handler<E>,
  beforeExecute?: Handler<E>,
): Handler<E> => {
  let awaiting = false;

  return throttle(async (e: E) => {
    if (awaiting) {
      return;
    }

    if (beforeExecute) {
      awaiting = true;
      try {
        await Promise.resolve(beforeExecute(e));
      } catch (err) {
        console.error(err);
      } finally {
        awaiting = false;
      }
    }

    if (handler && !awaiting) {
      handler(e);
    }
  }, 1000);
};
